import { render, staticRenderFns } from "./MemorizeView.vue?vue&type=template&id=48a7a65f&scoped=true&"
import script from "./MemorizeView.vue?vue&type=script&lang=js&"
export * from "./MemorizeView.vue?vue&type=script&lang=js&"
import style0 from "./MemorizeView.vue?vue&type=style&index=0&id=48a7a65f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a7a65f",
  null
  
)

/* custom blocks */
import block0 from "./MemorizeView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports